import { create } from "zustand";
import { persist } from "zustand/middleware";

export type SidebarMode = "expanded" | "rail";

export const SIDEBAR_WIDTH_EXPANDED = 208; // w-52
export const SIDEBAR_WIDTH_RAIL = 56; // w-14

export function widthFor(mode: SidebarMode): number {
  return mode === "expanded" ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_RAIL;
}

interface SidebarState {
  mode: SidebarMode;
  setMode: (m: SidebarMode) => void;
  toggleMode: () => void;
}

const DEFAULT_STATE: Pick<SidebarState, "mode"> = {
  // v2 (2026-05-22) flipped default `expanded` → `rail`. The sidebar now
  // hover-expands as an overlay (frontend-doctrine §4.6) so the resting
  // state is the compact icon rail. Cmd/Ctrl+B pins to expanded.
  mode: "rail",
};

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      ...DEFAULT_STATE,
      setMode: (mode) => set({ mode }),
      toggleMode: () =>
        set((s) => ({ mode: s.mode === "expanded" ? "rail" : "expanded" })),
    }),
    {
      name: "clawcraft-sidebar",
      version: 2,
      migrate: () => ({ ...DEFAULT_STATE }),
    },
  ),
);
